import { useNavigate, useLocation } from 'react-router-dom';

// Ref to store the navigate function and location
let navigateRef: any = null;
let locationRef: any = null;

export function setNavigateRef(navigate: any) {
  navigateRef = navigate;
}

export function setLocationRef(location: any) {
  locationRef = location;
}

export function getNavigateRef() {
  return navigateRef;
}

export function useNavigationRef() {
  const navigate = useNavigate();
  const location = useLocation();
  setNavigateRef(navigate);
  setLocationRef(location);
  return navigate;
}

// History-like object that uses the navigate function
export const history: any = {
  push: (path: string) => {
    if (navigateRef) {
      navigateRef(path);
    }
  },
  replace: (path: string) => {
    if (navigateRef) {
      navigateRef(path, { replace: true });
    }
  },
  go: (n: number) => {
    if (navigateRef) {
      navigateRef(n);
    }
  },
  goBack: () => {
    if (navigateRef) {
      navigateRef(-1);
    }
  },
  goForward: () => {
    if (navigateRef) {
      navigateRef(1);
    }
  },
  get location() {
    return locationRef;
  }
};
